import {
    Center,
    Stack,
    Text,
    Heading,
    Wrap,
    Link,
    Box,
    Button,
    Flex,
    HStack,
    IconButton,
    useColorModeValue as mode,
    VisuallyHidden,
    useMediaQuery,
} from "@chakra-ui/react";
import * as React from "react";
import { signIn, signOut, useSession } from "next-auth/client";
import NextLink from "next/link";
import { AccountSwitcher } from "components/account";
import { NavLink } from "../navbar/nav-link";
import { NavButton } from "../navbar/nav-button";
import { useRouter } from "next/dist/client/router";

import { Logo } from "components/logo";
// import { MobileNav } from "./mobile-nav";

import { FiLogOut } from "react-icons/fi";

const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : "https://app.tweethunter.io";

export const Header = ({ disableMenu = false, customLink }) => {
    const [session, loading] = useSession();
    const router = useRouter();
    const [isTooSmall] = useMediaQuery("(max-width: 900px)");

    return (
        <Box>
            <Flex p={5} pl={7} pt={10} justifyContent="space-between">
                <Center css={{}}>
                    {
                        disableMenu ? (
                            <Box>
                                <VisuallyHidden>Tweet Hunter</VisuallyHidden>
                                <Logo h="8" />
                            </Box>
                        ) : (
                            <Box as="a" href={customLink} rel="home" >
                                <VisuallyHidden>Tweet Hunter</VisuallyHidden>
                                <Logo h="8" />
                            </Box>
                        )
                    }
                </Center>
                <Box>
                    <Link fontWeight={600} textDecoration="underline" isExternal href={customLink}>
                        Learn more about Tweet Hunter
                    </Link>
                </Box>
            </Flex>
        </Box>
    );
};
